// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumb_wrapper__2Ig5v","breadcrumb":"Breadcrumb_breadcrumb__3BPcK","spacer":"Breadcrumb_spacer__2eJM2"};